import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { ThemeBase } from '@libs/themes';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ViewportService {
  private isMobile$?: Observable<boolean>;
  private isTablet$?: Observable<boolean>;
  private isDesktop$?: Observable<boolean>;
  private isDesktopXl$?: Observable<boolean>;
  private readonly isMobileQuery: string = `(max-width: ${ThemeBase.Breakpoints.md - 1}px)`;
  private readonly isTabletQuery: string = `(min-width: ${ThemeBase.Breakpoints.md - 1}px) and (max-width: ${ThemeBase.Breakpoints.lg - 1}px)`;
  private readonly isDesktopQuery: string = `(min-width: ${ThemeBase.Breakpoints.lg}px)`;
  private readonly isDesktopXlQuery: string = `(min-width: ${ThemeBase.Breakpoints.xl - 1}px)`;

  public constructor(private readonly breakpointObserver: BreakpointObserver) {
  }

  public isMobile(): Observable<boolean> {
    return this.isMobile$ ?? (this.isMobile$ = this.observeIsMobile());
  }

  public isTablet(): Observable<boolean> {
    return this.isTablet$ ?? (this.isTablet$ = this.observeIsTablet());
  }

  public isDesktop(): Observable<boolean> {
    return this.isDesktop$ ?? (this.isDesktop$ = this.observeIsDesktop());
  }

  public isDesktopXl(): Observable<boolean> {
    return this.isDesktopXl$ ?? (this.isDesktopXl$ = this.observeIsDesktopXl());
  }

  private observeIsMobile(): Observable<boolean> {
    return this.breakpointObserver.observe(this.isMobileQuery).pipe(
      map((state: BreakpointState) => state.matches),
    );
  }

  private observeIsTablet(): Observable<boolean> {
    return this.breakpointObserver.observe(this.isTabletQuery).pipe(
      map((state: BreakpointState) => state.matches),
    );
  }

  private observeIsDesktop(): Observable<boolean> {
    return this.breakpointObserver.observe(this.isDesktopQuery).pipe(
      map((state: BreakpointState) => state.matches),
    );
  }

  private observeIsDesktopXl(): Observable<boolean> {
    return this.breakpointObserver.observe(this.isDesktopXlQuery).pipe(
      map((state: BreakpointState) => state.matches),
    );
  }
}
